module.exports = __webpack_public_path__ + "static/media/globe.ae427306.png";